import { render, staticRenderFns } from "./RelatorioDeVendas.vue?vue&type=template&id=5a296ae7&scoped=true&"
import script from "./RelatorioDeVendas.vue?vue&type=script&lang=js&"
export * from "./RelatorioDeVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a296ae7",
  null
  
)

export default component.exports